import React from 'react';
import { Table } from 'semantic-ui-react';
import TableWrapper from '@/components/table/TableWrapper';
import PermissionsRows from '../containers/PermissionsRows';

const PermissionsTable = ({
  category,
  code,
  categories,
  disabled,
  grouping,
}) => (
  <TableWrapper className="aridhia-permissions-table">
    <Table.Body>
      <PermissionsRows
        category={category}
        code={code}
        categories={categories}
        disabled={disabled}
        grouping={grouping}
      />
    </Table.Body>
  </TableWrapper>
);

export default PermissionsTable;
